export const USERBET_ADDED = 'USERBET_ADDED'
export const USERBET_REMOVED = 'USERBET_REMOVED'
export const USERBET_CHANGED = 'USERBET_CHANGED'
export const INITIAL_USERBETS_LOADED = 'INITIAL_USERBETS_LOADED'
import { firebaseRef } from 'config'
import Firebase from 'firebase'


export function addUserbet(userbet) {
  return (dispatch, getState) => {
    userbet.user = getState().auth.user.id
    userbet.createdAt = Firebase.ServerValue.TIMESTAMP
    userbet.updatedAt = Firebase.ServerValue.TIMESTAMP
    userbet.closingLine = userbet.odds
    let ref = firebaseRef.child('userbets').push()
    ref.set(userbet)
  }
}

function userbetAdded(userbet) {
  return {
    type: USERBET_ADDED,
    userbet
  }
}

export function initialUserbetsLoaded(userbets) {
  return {
    type: INITIAL_USERBETS_LOADED,
    userbets
  }
}

export function editUserbet(id, change) {
  return () => firebaseRef.child(`userbets/${id}`).update(Object.assign({}, change, {updatedAt: Firebase.ServerValue.TIMESTAMP}))
}

export function deleteUserbet(id) {
  return () => {
    firebaseRef.child(`userbets/${id}`).set(null)
  }
}

function userbetChanged(userbet) {
  return {
    type: USERBET_CHANGED,
    userbet
  }
}

function userbetRemoved(id) {
  return {
    type: USERBET_REMOVED,
    id
  }
}


export function listenForUserbets(uid) {
  return (dispatch, getState) => {
    const ref = firebaseRef.child('userbets').orderByChild('user').equalTo(uid)
    ref.limitToLast(1).on('child_added', snap => {
      if (!getState().userbets.find(bet => bet.id === snap.key()))
        dispatch(userbetAdded(Object.assign({}, snap.val(), { id: snap.key() })))
    })
    ref.on('child_changed', snap => {
      dispatch(userbetChanged(Object.assign({}, snap.val(), { id: snap.key() })))
    })
    ref.on('child_removed', snap => {
      dispatch(userbetRemoved(snap.key()))
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/userbets.js
 **/